import React, { FC, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, fetchFormData, getEncryptedRoute, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddHotelHeader } from './AddHotelHeader'
import { Tr } from '../../../_metronic/i18n/Tr'
import { SortableUploadedImages, SortableNewImages } from '../components/SortableUploadedImages'

const AddHotelPhotos: FC = () => {
  let t = Tr()
  const { menuId } = useMenuIdPermissions()
 const tmp = sessionStorage.getItem('admin')
const adminId = tmp ? JSON.parse(tmp)?.adminId ?? '' : ''

  const location = useLocation()
  const editHotelId = (location.state as any)?.hotelId || ''

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const inputfileRef = useRef(null)
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [inputImage, setInputImage] = useState([]) as any
  const [uploadedImage, setUploadedImage] = useState([])
  const [hotelDetails, setHotelDetails] = useState([])
  // set error state
  const [error, setError] = useState([
    {
      subCategoryId: '',
      amenityId: '',
      hotelClass: '',
      hotelNameEN: '',
      contactPersonName: '',
      email: '',
      phoneNumber: '',
      descriptionEN: '',
      address: '',
      serviceLanguage: '',
      inputImage: '',
    },
  ])

  const handleTextClick = () => {
    let element: HTMLElement = document.getElementsByClassName('modaldocument')[0] as HTMLElement
    element.click()
  }
  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  const handleImageChange = (e: any) => {
    removeError('inputImage')
    const selectedFiles = Array.from(e.target.files)

    const validFiles = selectedFiles.filter((file: any) => {
      if (file.size > 5 * 1024 * 1024) { // 5 MB = 5 * 1024 * 1024 bytes
        toasterrormsg(`${file.name} is larger than 5 MB and was not added.`);
        return false;
      }
      return true;
    });
    // Check if adding selected files will exceed the limit
    if (inputImage.length + validFiles.length > 15) {
      // If it exceeds, only select files up to the limit
      const remainingCapacity = 15 - inputImage.length
      const limitedFiles = validFiles.slice(0, remainingCapacity)

      // Display a message or perform an action to notify the user about the limit
      toasterrormsg(t('Maximum 15 images can be uploaded.'))

      // Store the selected file names as paths
      const filePaths = limitedFiles.map((file) => file)

      // Append new images to the existing array of images
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    } else {
      // If it doesn't exceed, proceed as before
      const filePaths = validFiles.map((file) => file)
      setInputImage((prevImages: any) => [...prevImages, ...filePaths])
    }
  }


  // function for remove selected images
  const handleRemove1 = (index1: any) => {
    let tmparrimg = inputImage.filter((item: any, index: any) => index != index1)

    setInputImage(tmparrimg)
  }

  // remove uplaoded images
  const handleRemoveImage = async (index: any) => {
    var param = {
      hotelmediaId: index,
      adminId: adminId,
    }
    var res = await fetchData('vendor/public/deleteHotelMedia', param)

    if (res.status == '200') {
      hotelDetailsApiCall()
    } else {
      toasterrormsg(res.message)
    }
  }
  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (uploadedImage.length < 2) {
      if (inputImage.length == 0) {
        errorTmp[0].inputImage = t('Images Is Required')
        isValid = false
      } else if (inputImage.length < 2) {
        errorTmp[0].inputImage = t('Minimum 3 Images Is Required')
        isValid = false
      }
    }
    setError(errorTmp)
    return isValid
  }

  // add hotel images api call
  const addHotelImageApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('hotelId', editHotelId)
      param.append('adminId', adminId)
      if (inputImage.length != 0) {
        inputImage.forEach((file: any) => {
          param.append('image', file)
        })
      }
      var res = await fetchFormData('vendor/public/addHotalImage', param)
      if (res.status == '200') {
        toastsuccessmsg('Images Added Successfully!')
        const state = {
          hotelId: editHotelId,
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addhotelfacilities/', { menuId: menuId }), { state })
          setDisable(false)
        }, 1500)
      } else {
        toasterrormsg(res.message)
        setDisable(false)
              setLoading(false)

      }
    }
  }

  // hotel Details api call
  const hotelDetailsApiCall = async () => {
    var param: any = {
      hotelId: editHotelId,
    }
    var response: any = await fetchData('vendor/public/hotelDetailsV2', param)
    if (response.status == '200') {
      setHotelDetails(response.data)
      var data = response.data[0]

      setUploadedImage(data.images)
    } else {
      toasterrormsg(response.message)
    }
  }

  useEffect(() => {
    if (editHotelId != '') {
      hotelDetailsApiCall()
    }
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editHotelId != '' ? t('Edit Property Photos') : t('Add Property Photos')}
      </PageTitle>
      <AddHotelHeader hotelId={editHotelId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Property Photos')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {hotelDetails.length != 0 ? (
                            <>
                              {hotelDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['roomAndSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Label--> */}
                        <label className='fs-4 form-label'>{t('Upload images')}</label>
                        {/* <!--end::Label--> */}
                        <br />
                        <input
                          ref={inputfileRef}
                          style={{ display: 'none' }}
                          className='modaldocument'
                          type='file'
                          onChange={handleImageChange}
                          accept='image/*'
                          multiple
                        />
                        <span
                          className='btn btn-light text-primary cursor-pointer '
                          onClick={handleTextClick}
                        >
                          {' '}
                          {t('Attach Images')}
                        </span>
                        <div className='text-danger fw-bold'>{error[0].inputImage}</div>
                        <SortableUploadedImages
                          type='hotel'
                          images={uploadedImage}
                          onReorder={(images) => setUploadedImage(images as any)}
                          onRemove={handleRemoveImage}
                          adminId={adminId}
                          idKey='hotelmediaId'
                          droppableId='uploadedHotelImageList'
                        />
                        <SortableNewImages
                          images={inputImage}
                          onReorder={(images) => setInputImage(images as any)}
                          onRemove={handleRemove1}
                          droppableId='newHotelImageList'
                        />
                      </div>
                      {/* <!--end::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                <button
                  type='button'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={addHotelImageApi}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddHotelPhotos }
